module.exports = __webpack_public_path__ + "img/notify.3eca21b7.svg";